export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_REDIRECT_PATH = "AUTH_REDIRECT_PATH";

export const PEOPLE_START = "PEOPLE_START";
export const PEOPLE_SUCCESS = "PEOPLE_SUCCESS";
export const PEOPLE_FAIL = "PEOPLE_FAIL";

export const EDIT_PEOPLE_START = "EDIT_PEOPLE_START";
export const EDIT_PEOPLE_SUCCESS = "EDIT_PEOPLE_SUCCESS";
export const EDIT_PEOPLE_FAIL = "EDIT_PEOPLE_FAIL";

export const FETCH_PEOPLE_START = "FETCH_PEOPLE_START";
export const FETCH_PEOPLE_SUCCESS = "FETCH_PEOPLE_SUCCESS";
export const FETCH_PEOPLE_FAIL = "FETCH_PEOPLE_FAIL";

export const PRODUCT_START = "PRODUCT_START";
export const PRODUCT_SUCCESS = "PRODUCT_SUCCESS";
export const PRODUCT_REMOVE = "PRODUCT_REMOVE";
export const PRODUCT_FAIL = "PRODUCT_FAIL";
export const PRODUCT_REDIRECT_PATH = "PRODUCT_REDIRECT_PATH";

export const FETCH_PRODUCT_START = "FETCH_PRODUCT_START";
export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_FAIL = "FETCH_PRODUCT_FAIL";

export const CART_START = "CART_START";
export const CART_SUCCESS = "CART_SUCCESS";
export const CART_REMOVE = "CART_REMOVE";
export const CART_FAIL = "CART_FAIL";

export const FETCH_CART_START = "FETCH_CART_START";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const FETCH_CART_FAIL = "FETCH_CART_FAIL";

export const WISHLIST_START = "WISHLIST_START";
export const WISHLIST_SUCCESS = "WISHLIST_SUCCESS";
export const WISHLIST_REMOVE = "WISHLIST_REMOVE";
export const WISHLIST_FAIL = "WISHLIST_FAIL";

export const FETCH_WISHLIST_START = "FETCH_WISHLIST_START";
export const FETCH_WISHLIST_SUCCESS = "FETCH_WISHLIST_SUCCESS";
export const FETCH_WISHLIST_FAIL = "FETCH_WISHLIST_FAIL";

export const ORDER_START = "ORDER_START";
export const ORDER_SUCCESS = "ORDER_SUCCESS";
export const ORDER_FAIL = "ORDER_FAIL";

export const FETCH_ORDER_START = "FETCH_ORDER_START";
export const FETCH_ORDER_SUCCESS = "FETCH_ORDER_SUCCESS";
export const FETCH_ORDER_FAIL = "FETCH_ORDER_FAIL";
